var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.data)?_c('country-flag',{staticClass:"flag",attrs:{"country":_vm.data,"size":_vm.size}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }